// Same-origin API client. Every call carries the adoption-tracking headers and
// the session cookie (credentials: include). Unwraps the { success, data }
// envelope and throws ApiError on failure.

import { clientMode, installId } from "./pwa";

export class ApiError extends Error {
  code: string;
  status: number;
  constructor(code: string, message: string, status: number) {
    super(message);
    this.code = code;
    this.status = status;
  }
}

async function request<T>(method: string, path: string, body?: unknown): Promise<T> {
  const init: RequestInit = {
    method,
    credentials: "include",
    headers: {
      "content-type": "application/json",
      "x-tpfl-client": clientMode(),
      "x-tpfl-install": installId(),
    },
  };
  if (body !== undefined) init.body = JSON.stringify(body);

  const res = await fetch(path, init);
  let json: { success?: boolean; data?: T; error?: { code?: string; message?: string } } | null = null;
  try {
    json = await res.json();
  } catch {
    /* non-JSON */
  }
  if (!res.ok || !json?.success) {
    throw new ApiError(
      json?.error?.code || "HTTP_ERROR",
      json?.error?.message || `Request failed (${res.status})`,
      res.status,
    );
  }
  return json.data as T;
}

export const api = {
  get: <T>(path: string) => request<T>("GET", path),
  post: <T>(path: string, body?: unknown) => request<T>("POST", path, body),
  put: <T>(path: string, body?: unknown) => request<T>("PUT", path, body),
};
